import { useEffect } from 'react';

const useCartSync = (relay) => {
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'cart' && typeof relay.refetch === 'function') {
        relay.refetch({}, null);
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [relay]);
}

export default useCartSync;
